export const topNavigation = {
  chooseProject: 'Projekt wählen',
  counselor: 'Ratgeber',
  forCraftsmen: 'Für Handwerker',
  myHausHeld: 'myHausHeld',
  aboutUs: 'Über uns',
  getQuoteNow: 'Jetzt Offerte einholen',
  yourProject: 'Ihr Projekt',
  craftsmenLogin: 'Login für Handwerker',
  myHausHeldLogin: 'Login myHausHeld',
  altAccountIcon: 'Loginbereich',
  contact: 'Kontakt',
  itIsSoSimple: `So einfach geht's`,
  yourAdvantages: 'Ihre Vorteile',
  mortgage: 'Hypothek',
  new: 'Neu',
  sponsoring: 'Ratgeber publizieren',
}
